import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Form as FormBS } from "react-bootstrap";
import Toggle from "react-toggle";
import ReactTooltip from "react-tooltip";

import { Form, Field } from "formik";
import moment from "moment";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import getSymbolFromCurrency from "currency-symbol-map";

import { chargeCalculation, resetCharges } from "../../../../../../general_redux/calendar/actions";
import CustomDate from "../../../../../../components/CustomDate";
import { addDaysToDateObj } from "../../../../../../common/functions/utils";
import ContactForm from "./ContactForm";
import styles from "./addnewbooking.module.css";


function BookingForm(props) {

    const dispatch = useDispatch();

    const {
        rentals,
        findRentalDetail,
        newBookingFromEmptyNight,
        values,
        errors,
        setFieldValue,
        handleChange,
        handleSubmit,
    } = props;

    const ratesList = useSelector(({ rates }) => rates && rates.rateSettings);
    const currentCharges = useSelector(({ calendar }) => calendar && calendar.currentCharges);
    const { numberOf, allowBookingFor } = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [currentRentalDetail, setCurrentRentalDetail] = useState(findRentalDetail(newBookingFromEmptyNight?.rentalId));
    const [showMoreBookingDetails, setShowMoreBookingDetails] = useState(false);
    const [showMorePaymentDetails, setShowMorePaymentDetails] = useState(false);

    const paymentOpt = ["Payment Pending", "Partially Paid", "Paid"];

    const colorDictionary = useSelector(({ generalSetting }) => {
        const colorsSetting = generalSetting && generalSetting.setting.colors;
        const map = [];
        for (const key in colorsSetting) {
            if (key.startsWith("color")) {
                map.push(colorsSetting[key]);
            }
        };
        return map;
    });

    const getChannelOptions = (channels) => {
        const channelOptions = channels.map((item) => {
            const ChannelNameObject = getChannelName(item.channel);
            return { label: ChannelNameObject.label, value: ChannelNameObject.value };
        });
        return [{ label: "Beehaz", value: "Beehaz" }, ...channelOptions];
    };

    const getChannelName = (channel) => {
        if (channel.ota === "Other")
            return { label: `${channel.name} (iCal)`, value: channel.name }
        if (channel.ota === "VRBO")
            return { label: "VRBO (HomeAway) (iCal)", value: channel.ota }
        else
            return { label: `${channel.ota} (iCal)`, value: channel.ota }
    };

    const findRateDetail = (rentalId) => {
        const findRate = ratesList.find((rate) => Number(rate.rentalId) === Number(rentalId));
        return findRate || { minimumStayRequirement: 0, maximumStayRequirement: 0 };
    };

    const channels = useSelector(({ icalChannels }) => icalChannels && getChannelOptions(icalChannels.channels));

    useEffect(() => {
        const rateDetail = findRateDetail(newBookingFromEmptyNight?.rentalId);
        setFieldValue("minStay", rateDetail.minimumStayRequirement);
        setFieldValue("maxStay", rateDetail.maximumStayRequirement);

        setFieldValue("arrive", newBookingFromEmptyNight?.arrive);
        setCurrentRentalDetail(findRentalDetail(newBookingFromEmptyNight?.rentalId));
        
        setFieldValue("rentalId", currentRentalDetail.id);
        setFieldValue("checkInTimeAt", currentRentalDetail.checkInTimeAt);
        setFieldValue("checkOutTimeAt", currentRentalDetail.checkOutTimeAt);
        setFieldValue("checkInTime", currentRentalDetail.checkinTime);
        setFieldValue("checkOutTime", currentRentalDetail.checkoutTime);
        setFieldValue("maxOccup", currentRentalDetail.maxOccup);
        setFieldValue("maxChild", currentRentalDetail.maxChild);

        return () => { dispatch(resetCharges()) };
    }, [])

    useEffect(() => {

        if (
            values.arrive &&
            values.depart &&
            Number(values.rentalId) &&
            Number(values.totalGuests) &&
            (Number(values.adult) > 0)
        ) {
            dispatch(chargeCalculation({
                bookingType: "booking",
                rentalId: Number(values.rentalId),
                arrive: moment(values.arrive).format("YYYY-MM-DD"),
                depart: moment(values.depart).format("YYYY-MM-DD"),
                noOfAdults: Number(values.adult),
                noOfChildren: Number(values.children),
                discount: Number(values.discount),
                extraCharge: Number(values.extraCharge),
            }));
            setFieldValue("nights", moment(values.depart).diff(moment(values.arrive), "days"));
        };

        const rateDetail = findRateDetail(values.rentalId);
        setFieldValue("minStay", rateDetail.minimumStayRequirement);
        setFieldValue("maxStay", rateDetail.maximumStayRequirement);

        setCurrentRentalDetail(findRentalDetail(values.rentalId));
        setFieldValue("checkInTimeAt", currentRentalDetail.checkInTimeAt);
        setFieldValue("checkOutTimeAt", currentRentalDetail.checkOutTimeAt);
        setFieldValue("checkInTime", currentRentalDetail.checkinTime);
        setFieldValue("checkOutTime", currentRentalDetail.checkoutTime);
        setFieldValue("maxOccup", currentRentalDetail.maxOccup);
        setFieldValue("maxChild", currentRentalDetail.maxChild);

    }, [
        values.rentalId,
        values.arrive,
        values.depart,
        values.adult,
        values.children,
        values.extraCharge,
        values.discount,
    ]);

    useEffect(() => {
        if (currentCharges) {
            setFieldValue("price", Number((currentCharges.daily_rate + currentCharges.extra_guest_fees).toFixed(2)));
            setFieldValue("feesAndTaxes", Number(currentCharges.fees + currentCharges.taxes).toFixed(2));
            setFieldValue("fees", Number(currentCharges.fees).toFixed(2));
            setFieldValue("taxes", Number(currentCharges.taxes).toFixed(2));
            setFieldValue("baseRate", Number(currentCharges.daily_rate).toFixed(2));
            setFieldValue("extraGuestFee", Number(currentCharges.extra_guest_fees).toFixed(2));
            setFieldValue("finalPrice", Number(currentCharges.total).toFixed(2));

            if (!currentCharges.maxStay) {
                setFieldValue("maxStay", currentCharges.maxStayConstrain);
            };

            if (!currentCharges.minStay) {
                setFieldValue("minStay", currentCharges.minStayConstrain);
            };
        };
    }, [currentCharges]);

    return (
        <Form onSubmit={handleSubmit} autoComplete="off">
            <h3 className={styles.header}>Booking Details</h3>
            <Row>
                <Col>
                    <div className={`d-flex ${styles.form_wrapper}`} key="selectRental">
                        <div className={`d-flex ${styles.form_title}`}>
                            Select rental*:
                        </div>
                        <div className="w-100">
                            <Field
                                as="select"
                                type="number"
                                name="rentalId"
                                value={values.rentalId}
                                className={errors.rentalId ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                onChange={handleChange}
                            >
                                <option value={0} label={"---Select Rental---"} />
                                {rentals.map((opt) => (
                                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                                ))}
                            </Field>
                            <div className={errors.rentalId ? styles.form_error : styles.form_error_hidden}>
                                {errors.rentalId}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="arrive">
                        <div className={`d-flex ${styles.form_title}`}>
                            Arrival date*:
                        </div>
                        <div className="w-100">
                            <CustomDate
                                name="arrive"
                                value={values.arrive}
                                handleChange={(date) => setFieldValue("arrive", date)}
                                hasError={errors.arrive}
                                customClass={errors.arrive ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                max={values.depart ?
                                    new Date(`${moment(values.depart).format("YYYY-MM-DD")}`)
                                    :
                                    new Date(`${moment().add(numberOf, (allowBookingFor === "months" ? 'M' : 'y')).format('YYYY-MM-DD')}`)
                                }
                            />
                            <div className={errors.arrive ? styles.form_error : styles.form_error_hidden}>
                                {errors.arrive}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="depart">
                        <div className={`d-flex ${styles.form_title}`}>
                            Departure date*:
                        </div>
                        <div className="w-100">
                            <CustomDate
                                name="depart"
                                value={values.depart}
                                handleChange={(date) => setFieldValue("depart", date)}
                                hasError={errors.depart}
                                customClass={errors.depart ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                min={values?.arrive ? addDaysToDateObj(values.arrive, 1) : null}
                                max={new Date(`${moment().add(numberOf, allowBookingFor === "months" ? "M" : "y").format("YYYY-MM-DD")}`)}
                            />
                            <div className={errors.depart ? styles.form_error : styles.form_error_hidden}>
                                {errors.depart}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="nights">
                        <div className={`d-flex ${styles.form_title}`}>
                            Total nights:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="nights"
                                value={values.nights}
                                disabled={true}
                                className={errors.nights ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors.nights ? styles.form_error : styles.form_error_hidden}>
                                {errors.nights}
                            </div>
                        </div>
                    </div>
                    <div key="color">
                        <div className={`d-flex ${styles.form_title} ${styles.labelColor}`}>
                            Choose colour:
                        </div>
                        <div className={styles.containerColor}>
                            {colorDictionary.map((item, index) => (
                                <div
                                    className={`${styles.containerBox} ${(values.color === item) ? ` active1` : ``}`}
                                    style={{ background: `${item}` }}
                                    onClick={() => setFieldValue("color", item)}
                                    key={index}
                                />
                            ))}
                            <Field
                                type="color"
                                name="color"
                                value={values.color}
                                onChange={handleChange}
                                className={styles.form_entry_color}
                            />
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className={`d-flex ${styles.form_wrapper}`} key="adult">
                        <div className={`d-flex ${styles.form_title}`}>
                            Adults:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="adult"
                                value={values.adult || ""}
                                onChange={(e) => {
                                    const adultValue = e.target.value;
                                    setFieldValue("adult", adultValue);
                                    setFieldValue("totalGuests", Number(adultValue) + Number(values.children));
                                }}
                                placeholder={0}
                                className={errors.adult ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors.adult ? styles.form_error : styles.form_error_hidden}>
                                {errors.adult}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="children">
                        <div className={`d-flex ${styles.form_title}`}>
                            Children:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="children"
                                value={values.children || ""}
                                onChange={(e) => {
                                    const childrenValue = e.target.value;
                                    setFieldValue("children", childrenValue);
                                    setFieldValue("totalGuests", Number(childrenValue) + Number(values.adult));
                                }}
                                placeholder={0}
                                className={errors.children ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors.children ? styles.form_error : styles.form_error_hidden}>
                                {errors.children}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="babies">
                        <div className={`d-flex ${styles.form_title}`}>
                            Babies:
                            <InfoOutlinedIcon
                                fontSize="small"
                                color="inherit"
                                data-tip
                                data-for="babies"
                                className={styles.toolTipIcon}
                            />
                            <ReactTooltip place="bottom" type="dark" id="babies" effect="solid" className={styles.toolTip}>
                                <span>
                                    Babies are not counted in the number of total guests (which consists of the total number of adults + the total number of children).
                                    This means they do not have any effect on the price calculation (while the number of adults and children influence the price when you have per person fees in your pricing).
                                </span>
                            </ReactTooltip>
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="babies"
                                value={values.babies || ""}
                                onChange={handleChange}
                                placeholder={0}
                                className={errors.babies ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="totalGuest">
                        <div className={`d-flex ${styles.form_title}`}>
                            Number of guests:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="totalGuests"
                                value={values.totalGuests}
                                disabled={true}
                                className={(errors.totalGuests) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors.totalGuests ? styles.form_error : styles.form_error_hidden}>
                                {errors.totalGuests}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="pets">
                        <div className={`d-flex ${styles.form_title}`}>
                            Pets:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="pets"
                                value={values.pets || ""}
                                onChange={handleChange}
                                placeholder={0}
                                className={errors.pets ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors.pets ? styles.form_error : styles.form_error_hidden}>
                                {errors.pets}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="miniNotes">
                        <div className={`d-flex ${styles.form_title}`}>
                            Mini notes:
                            <InfoOutlinedIcon
                                fontSize="small"
                                color="inherit"
                                data-tip
                                data-for="miniNotes"
                                className={styles.toolTipIcon}
                            />
                            <ReactTooltip place="bottom" type="dark" id="miniNotes" effect="solid" className={styles.toolTip}>
                                <span>
                                    Write a short note to be displayed in the booking information summary box that appears when you click on a reservation in the calendar.
                                </span>
                            </ReactTooltip>
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="miniNotes"
                                value={values.miniNotes}
                                onChange={handleChange}
                                className={`${styles.form_entry}`}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            {showMoreBookingDetails && (
                <>
                    <hr />
                    <Row>
                        <Col>
                            <div className={`d-flex ${styles.form_wrapper}`} key="source:">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Source:
                                </div>
                                <div className="w-100">
                                    <Field
                                        as="select"
                                        name="source"
                                        value={values.source}
                                        onChange={handleChange}
                                        className={errors.source ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    >
                                        {channels.map((opt, index) => (
                                            <option key={index} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </Field>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="checkintime">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Check-in time*:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="time"
                                        name="checkInTime"
                                        value={values.checkInTime}
                                        onChange={handleChange}
                                        className={errors.checkInTime ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors.checkInTime ? styles.form_error : styles.form_error_hidden}>
                                        {errors.checkInTime}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="checkouttime">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Check-out time*:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="time"
                                        name="checkOutTime"
                                        value={values.checkOutTime}
                                        onChange={handleChange}
                                        className={errors.checkOutTime ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors.checkOutTime ? styles.form_error : styles.form_error_hidden}>
                                        {errors.checkOutTime}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className={`w-100 ${styles.form_wrapper}`} key="notes">
                                <div className={`d-flex ${styles.form_title}`}>
                                    <p style={{ fontWeight: "bold" }}>
                                        Notes:
                                    </p>
                                    <InfoOutlinedIcon
                                        fontSize="small"
                                        color="inherit"
                                        data-tip
                                        data-for="notes"
                                        className={styles.toolTipIcon}
                                    />
                                    <ReactTooltip place="bottom" type="dark" id="notes" effect="solid" className={styles.toolTip}>
                                        <span>
                                            Write longer notes specific to this booking here.
                                        </span>
                                    </ReactTooltip>
                                </div>
                                <div className="w-100">
                                    <Field
                                        as="textarea"
                                        name="notes"
                                        value={values.notes}
                                        onChange={handleChange}
                                        rows={4}
                                        autoComplete="off"
                                        className={`w-100 h-100 ${styles.form_entry}`}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            <div className="d-flex justify-content-start">
                <h3 className={styles.showMoreDetails}>Show {!showMoreBookingDetails ? "more" : "less"}</h3>
                {!showMoreBookingDetails ?
                    <ExpandMoreIcon className={styles.btnArrowMore} onClick={() => setShowMoreBookingDetails(true)} />
                    :
                    <ExpandLessIcon className={styles.btnArrowLess} onClick={() => setShowMoreBookingDetails(false)} />
                }
            </div>
            <hr />
            <h3 className={`${styles.header} ${styles.headerGuestDetails}`}>Guest Details</h3>
            <ContactForm {...props} contactType="guest" />
            <hr />
            <h3 className={styles.header}>Additional Contacts</h3>
            <Row>
                <Col>
                    <div className={`d-flex ${styles.form_wrapper} ${styles.checkboxContainer}`} key="checkboxAdditionalGuests">
                        <FormBS.Check
                            type="checkbox"
                            name="checkboxAdditionalGuests"
                            checked={values.checkboxAdditionalGuests}
                            onChange={() => {
                                if (values.checkboxAdditionalGuests) {
                                    setFieldValue("additionalGuestNames", "");
                                };
                                setFieldValue("checkboxAdditionalGuests", !values.checkboxAdditionalGuests);
                            }}
                            className={styles.checkboxAdditionalGuests}
                        />
                        <div className={`w-100 d-flex ${styles.form_title}`}>
                            Include additional guest names.
                        </div>
                    </div>
                    {values.checkboxAdditionalGuests && (
                        <div className={`col-lg-6 m-0 p-0 d-flex ${styles.form_wrapper} ${styles.additionalGuestNamesContainer}`} key="additionalGuestNames">
                            <div className={`col-lg-4 ml-0 pl-0 d-flex ${styles.form_title}`}>
                                Guest names:
                            </div>
                            <div className="col-lg-8 m-0 p-0">
                                <Field
                                    type="text"
                                    name="additionalGuestNames"
                                    value={values.additionalGuestNames}
                                    onChange={handleChange}
                                    className={errors.additionalGuestNames ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                />
                                <div className={errors.additionalGuestNames ? styles.form_error : styles.form_error_hidden}>
                                    {errors.additionalGuestNames}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={`d-flex ${styles.form_wrapper} ${styles.checkboxContainer}`} key="checkboxGuestMadeReservation">
                        <FormBS.Check
                            type="checkbox"
                            name="booker.checkboxGuestMadeReservation"
                            checked={values.booker.checkboxGuestMadeReservation}
                            onChange={() => {
                                setFieldValue("booker.checkboxGuestMadeReservation", !values.booker.checkboxGuestMadeReservation);
                            }}
                            className={styles.checkboxGuestMadeReservation}
                        />
                        <div className={`w-100 d-flex ${styles.form_title}`}>
                            The guest made the reservation.
                            <InfoOutlinedIcon
                                fontSize="small"
                                color="inherit"
                                data-tip
                                data-for="checkboxGuestMadeReservation"
                                className={styles.toolTipIcon}
                            />
                            <ReactTooltip place="bottom" type="dark" id="checkboxGuestMadeReservation" effect="solid" className={styles.toolTip}>
                                <span>
                                    If someone is making a reservation on behalf of another person, uncheck this field to add the booker to your contact list and associate them with the reservation.
                                </span>
                            </ReactTooltip>
                        </div>
                    </div>
                    {!values.booker.checkboxGuestMadeReservation && (
                        <div className={styles.headerBookerDetails}>
                            <ContactForm {...props} contactType="booker" />
                        </div>
                    )}
                </Col>
            </Row>
            <hr />
            <h3 className={styles.header}>Payment Details</h3>
            <Row>
                <Col>
                    <div className={`d-flex ${styles.form_wrapper}`} key="finalPrice">
                        <div className={`d-flex ${styles.form_title}`}>
                            Final price:
                            <InfoOutlinedIcon
                                fontSize="small"
                                color="inherit"
                                data-tip
                                data-for="finalPriceIcon"
                                className={styles.toolTipIcon}
                            />
                            <ReactTooltip place="bottom" type="dark" id="finalPriceIcon" effect="solid" className={styles.toolTip}>
                                <span>
                                    Considers rates, extra guest fees, fees, and taxes.
                                    These can be managed by clicking on the Rates icon.
                                    Any discount or charge you have set above are also considered here.
                                    You can manually overwrite the total for this booking by editing the booking later.
                                </span>
                            </ReactTooltip>
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name="finalPrice"
                                value={Number(values.finalPrice).toFixed(2)}
                                className={(errors.finalPrice) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                disabled={true}
                            />
                            <div className={errors.finalPrice ? styles.form_error : styles.form_error_hidden}>
                                {errors.finalPrice}
                            </div>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className={`d-flex ${styles.form_wrapper}`} key="paymentStatus">
                        <div className={`d-flex ${styles.form_title}`}>
                            Payment status:
                        </div>
                        <div className="w-100">
                            <Field
                                as={"select"}
                                name="paymentStatus"
                                className={(errors.paymentStatus) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            >
                                <option key={""} value={""} disabled={true} label={"--Select Status--"} />
                                {paymentOpt.map((opt) => (
                                    <option value={opt} key={opt}>{opt}</option>
                                ))}
                            </Field>
                        </div>
                    </div>
                </Col>
            </Row>
            {showMorePaymentDetails && (
                <>
                    <hr />
                    <Row>
                        <Col>
                            <div className={`d-flex ${styles.form_wrapper}`} key="price">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Price:
                                    <InfoOutlinedIcon
                                        fontSize="small"
                                        color="inherit"
                                        data-tip
                                        data-for="priceInfoIcon"
                                        className={styles.toolTipIcon}
                                    />
                                    <ReactTooltip place="bottom" type="dark" id="priceInfoIcon" effect="solid" className={styles.toolTip}>
                                        <span>
                                            The price takes into account the rates set for these dates and extra guest fees.
                                            These can be managed by clicking on the Rates icon.
                                            You can manually overwrite the total for this booking by editing the booking later.
                                        </span>
                                    </ReactTooltip>
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name="price"
                                        className={(errors.price) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                        value={Number(values.price).toFixed(2)}
                                        disabled={true}
                                    />
                                    <div className={errors.price ? styles.form_error : styles.form_error_hidden}>
                                        {errors.price}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="feesAndTaxes">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Fees and taxes:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name="feesAndTaxes"
                                        value={Number(values.feesAndTaxes).toFixed(2)}
                                        className={(errors.feesAndTaxes) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                        disabled={true}
                                    />
                                </div>
                                <div className={errors.feesAndTaxes ? styles.form_error : styles.form_error_hidden}>
                                    {errors.feesAndTaxes}
                                </div>
                            </div>
                            <div className={`${styles.paragraphBelowSearch} d-flex align-items-center`}>
                                <hr className={`${styles.hrClass} flex-grow-1`} />
                                <p className="mx-3">or set final price manually</p>
                                <hr className={`${styles.hrClass} flex-grow-1`} />
                            </div>
                            <div className={`pb-2 d-flex flex-direction-column justify-content-between ${styles.overWriteToggleContainer}`}>
                                <div className={`d-flex flex-direction-row`}>
                                    <div className={`d-flex ${styles.form_title}`}>
                                        <span className={styles.subHeader}>
                                            Overwrite total due
                                        </span>
                                        <InfoOutlinedIcon
                                            fontSize="small"
                                            color="inherit"
                                            data-tip
                                            data-for="overWrite"
                                            className={styles.toolTipIcon}
                                        />
                                        <ReactTooltip place="top" type="dark" id="overWrite" effect="solid" className={styles.toolTip}>
                                            <p>
                                                Overwrite the total due for this reservation.
                                                Doing this will erase the system payment calculation and any charges or discounts you set for this booking.
                                                This will become the total amount due for this booking.
                                            </p>
                                            <p>
                                                If you set this amount to 0, the system’s payment calculations will be used again, along with charges or discounts you set above.
                                                If you intend not to charge for this booking, set the discount amount equal to the total rent.
                                            </p>
                                        </ReactTooltip>
                                    </div>
                                </div>
                                <Toggle
                                    icons={false}
                                    checked={values.overWriteTotalToggle}
                                    name="overWriteTotalToggle"
                                    onChange={handleChange}
                                    className={styles.toggle}
                                />
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`}>
                                <div className={styles.payment_title_sm}>
                                    <b>New total: </b>
                                </div>
                                <div>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="text"
                                            name="newTotal"
                                            value={values.overWriteTotalToggle ? (values.newTotal || '') : ''}
                                            placeholder={0}
                                            onChange={handleChange}
                                            disabled={!values.overWriteTotalToggle}
                                            className={styles.payment_entry_amount}
                                        />
                                        <div className={`${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(currentRentalDetail.currency)}`}</div>
                                    </div>
                                    <div className={errors.newTotal ? styles.form_error : styles.form_error_hidden}>
                                        {errors.newTotal}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className={`d-flex ${styles.form_wrapper}`} key="discount">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Discount:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name="discount"
                                        className={(errors.discount) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                        value={values.discount || ""}
                                        placeholder={0}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={errors.discount ? styles.form_error : styles.form_error_hidden}>
                                    {errors.discount}
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="extraCharge">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Extra charge:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name="extraCharge"
                                        value={values.extraCharge || ""}
                                        placeholder={0}
                                        className={(errors.extraCharge) ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={errors.extraCharge ? styles.form_error : styles.form_error_hidden}>
                                    {errors.extraCharge}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            <div className="d-flex justify-content-start">
                <h3 className={styles.showMoreDetails}>Show {!showMorePaymentDetails ? "more" : "less"}</h3>
                {!showMorePaymentDetails ?
                    <ExpandMoreIcon className={styles.btnArrowMore} onClick={() => setShowMorePaymentDetails(true)} />
                    :
                    <ExpandLessIcon className={styles.btnArrowLess} onClick={() => setShowMorePaymentDetails(false)} />
                }
            </div>
            <hr />
            <Row className="mt-3 d-flex justify-content-center">
                <button
                    type="submit"
                    className={styles.settings_save}
                    disabled={disableSubmit}
                >
                    Save Changes
                </button>
            </Row>
        </Form>
    )
};
export default BookingForm;
